export const ADD_REGULATION = "ADD_REGULATION";
export const REMOVE_REGULATION = "REMOVE_REGULATION";
export const RESET_REGULATION = "RESET_REGULATION";
